(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    function torqeloMenus(scope) {
    scope.querySelectorAll('.mega-menu').forEach((menu) => {
      if (menu.dataset.torqeloReady) return;
      menu.dataset.torqeloReady = 'true';
      let openTimer;
      let closeTimer;
      const summary = menu.querySelector('summary');
      const content = menu.querySelector('.mega-menu__content');
      const clearTimers = () => {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
      };
      const close = () => {
        clearTimers();
        menu.open = false;
        summary.setAttribute('aria-expanded', 'false');
      };
      menu.addEventListener('mouseenter', () => {
        if (!matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
        clearTimeout(closeTimer);
        if (menu.open) return;
        clearTimeout(openTimer);
        openTimer = setTimeout(() => {
          document.querySelectorAll('.mega-menu[open]').forEach((other) => {
            if (other !== menu) {
              other.open = false;
              other.querySelector('summary').setAttribute('aria-expanded', 'false');
            }
          });
          menu.open = true;
          summary.setAttribute('aria-expanded', 'true');
        }, 150);
      });
      menu.addEventListener('mouseleave', () => {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          if (!menu.matches(':hover') && !menu.contains(document.activeElement)) close();
        }, 1200);
      });
      content.addEventListener('mouseenter', () => clearTimeout(closeTimer));
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { close(); summary.focus(); }
      });
      document.addEventListener('click', (event) => {
        if (!menu.contains(event.target)) close();
      });
    });
  }
  torqeloMenus(document);
  document.addEventListener('shopify:section:load', (event) => torqeloMenus(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["torqelo-mobile-nav"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-torqelo-menu-trigger]');
    if (!trigger) return;
    const menuButton = document.querySelector('.header__icon--menu');
    if (menuButton) menuButton.click();
  });
  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, async ({ cartData }) => {
      let count = cartData?.item_count;
      if (typeof count !== 'number') {
        try {
          const response = await fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } });
          if (response.ok) count = (await response.json()).item_count;
        } catch {}
      }
      if (typeof count !== 'number') return;
      document.querySelectorAll('[data-torqelo-cart-count]').forEach((badge) => {
        badge.textContent = count;
        badge.hidden = count === 0;
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["torqelo-volume-tiers"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-torqelo-quantity]')) return;
    const quantity = event.target.closest('product-info')?.querySelector('.quantity__input');
    if (!quantity) return;
    quantity.value = event.target.value;
    quantity.dispatchEvent(new Event('change', { bubbles: true }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["torqelo-wishlist"] && !Shopify.designMode) return;
  try {
    (() => {
    const key = 'torqelo-saved-v1';
    let saved = [];
    const valid = (item) => {
      if (!item || typeof item.url !== 'string' || typeof item.title !== 'string') return false;
      try { const u = new URL(item.url, location.origin); return u.origin === location.origin && u.pathname.includes('/products/'); } catch { return false; }
    };
    try { const data = JSON.parse(localStorage.getItem(key) || '[]'); if (Array.isArray(data)) saved = data.filter(valid).slice(0,100); } catch {}
    const dialog = document.getElementById('TorqeloWishlist');
    if (!dialog) return;
    const render = () => {
      document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
        button.hidden = false;
        button.setAttribute('aria-pressed', String(saved.some((item) => item.url === button.dataset.url)));
      });
      document.querySelectorAll('[data-wishlist-open]').forEach((button) => { button.hidden = false; });
      document.querySelectorAll('[data-wishlist-count]').forEach((node) => { node.textContent = saved.length || ''; });
      const list = dialog.querySelector('[data-wishlist-list]');
      list.replaceChildren();
      saved.forEach((item) => {
        const li = document.createElement('li');
        const link = document.createElement('a');
        link.href = item.url;
        link.textContent = item.title;
        li.append(link);
        list.append(li);
      });
      dialog.querySelector('[data-wishlist-empty]').hidden = saved.length > 0;
      dialog.querySelector('[data-wishlist-clear]').hidden = saved.length === 0;
    };
    const persist = () => { try { localStorage.setItem(key, JSON.stringify(saved)); } catch {} render(); };
    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-wishlist-toggle]');
      if (toggle) {
        const item = { title: toggle.dataset.title, url: toggle.dataset.url };
        if (!valid(item)) return;
        if (saved.some((x) => x.url === item.url)) saved = saved.filter((x) => x.url !== item.url);
        else saved = [item, ...saved].slice(0,100);
        persist();
      }
      if (event.target.closest('[data-wishlist-open]')) { render(); dialog.showModal(); }
      if (event.target.closest('[data-wishlist-clear]')) { saved = []; persist(); }
    });
    document.addEventListener('shopify:section:load', render);
    if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.sectionRefreshed, render);
    const main = document.querySelector('main');
    if (main) new MutationObserver((records) => { if(records.some(r=>r.addedNodes.length)) render(); }).observe(main,{childList:true,subtree:true});
    render();
  })();
  } catch(e) { console.error(e); }
})();

})();
